import React from 'react';
import Select from 'react-select';

import { StatsFilters } from '../../../../../domain/statsFilters';


type YearPickerProps = {
    yearFilter: NonNullable<StatsFilters['yearFilter']>;
    onChange: (newYearFilter: NonNullable<StatsFilters['yearFilter']>) => void;
    startYear: number;
}

export const YearPicker = ({ yearFilter, onChange, startYear }: YearPickerProps) => {
    const handleYearChange = (newYear: number) => {
        onChange({
            year: newYear,
        });
    };

    const currentYear = new Date().getFullYear();
    const yearsCount = currentYear - startYear + 1;
    const years = Array.from({ length: yearsCount }, (_, i) => currentYear - i);

    const yearOptions = years.map(year => ({
        value: year,
        label: year.toString()
    }));

    const selectedYear = yearOptions.find(option => option.value === yearFilter.year);

    return (
        <Select
            value={selectedYear}
            onChange={(value) => handleYearChange(value?.value as number)} // because this Select is not clearable it's never going to be an undefined
            options={yearOptions}
            placeholder="Wybierz rok"
            className="me-3"
        />

    );
};